import React from "react";
import { Spin } from "antd";
import { MathText } from "./MathText";
import { useResolveQuizHtml } from "../../hooks/useHandleFile";

type QuizQuestionContentProps = {
  html?: string | null;
  imageSrcs?: string[];
  className?: string;
};

export const QuizQuestionContent: React.FC<QuizQuestionContentProps> = ({
  html,
  imageSrcs = [],
  className,
}) => {
  const { resolvedHtml, isResolvingImages } = useResolveQuizHtml(html, imageSrcs);

  if (!html) return null;

  if (isResolvingImages) {
    return <Spin size="small" />;
  }

  return <MathText text={resolvedHtml} isHtml className={className} />;
};
